"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _recharts = require("recharts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * レーダーチャート
 * @prop {number} chartHeight - チャートの高さ
 * @prop {number} chartWidth - チャートの幅
 * @prop {number} domainMax - 目盛の最大値
 * @prop {number} tickCount - 目盛の数
 * @prop {array} chartData - データ
 * @prop {string} chartData.chosaColumnCd - 調査項目コード
 * @prop {string} chartData.chosaColumnNm - 調査項目名
 * @prop {string} chartData.chosakoumokuTaishogaiFlg - 調査項目対象外フラグ
 * @prop {string} chartData.gyomuNaiyo - 業務内容
 * @prop {number} chartData.score - 成熟度評価点
 * @prop {number} chartData.totalAverageScore - 全体平均点
 * @prop {array} radarAttr - 属性
 * @prop {string} radarAttr.name - 名称
 * @prop {string} radarAttr.key - キー
 * @prop {string} radarAttr.color - 色
 * @prop {string} dataName - データ名（チャートの軸に表示される）
 * @prop {string} [label] - ラベルに表示する文字列
 */
const CRadarChart = props => {
  const {
    label,
    chartHeight,
    chartWidth,
    domainMax,
    tickCount,
    radarAttr,
    chartData,
    dataKey
  } = props;
  const radarList = radarAttr.map((item, idx) => {
    return /*#__PURE__*/_react.default.createElement(_recharts.Radar, {
      key: "radar-".concat(item.key, "-").concat(idx),
      name: item.name,
      dataKey: item.key,
      dot: "true",
      stroke: item.color,
      fill: item.color,
      fillOpacity: 0.0
    });
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: label
  }), /*#__PURE__*/_react.default.createElement(_recharts.RadarChart, {
    height: chartHeight,
    width: chartWidth,
    cx: "50%",
    cy: "50%",
    data: chartData
  }, /*#__PURE__*/_react.default.createElement(_recharts.Legend, {
    verticalAlign: "top",
    height: 60,
    iconType: "line",
    margin: {
      top: 0,
      left: 0,
      right: 0,
      bottom: 50
    }
  }), /*#__PURE__*/_react.default.createElement(_recharts.PolarGrid, null), /*#__PURE__*/_react.default.createElement(_recharts.PolarAngleAxis, {
    dataKey: dataKey,
    fontSize: "11px"
  }), /*#__PURE__*/_react.default.createElement(_recharts.PolarRadiusAxis, {
    angle: 90,
    domain: [-1, domainMax],
    tickCount: tickCount === undefined ? domainMax + 2 : tickCount
  }), radarList));
};
CRadarChart.propTypes = {
  chartHeight: _propTypes.default.number.isRequired,
  chartWidth: _propTypes.default.number.isRequired,
  domainMax: _propTypes.default.number.isRequired,
  tickCount: _propTypes.default.number.isRequired,
  chartData: _propTypes.default.arrayOf(_propTypes.default.shape({
    chosaColumnCd: _propTypes.default.string,
    chosaColumnNm: _propTypes.default.string,
    chosakoumokuTaishogaiFlg: _propTypes.default.string,
    gyomuNaiyo: _propTypes.default.string,
    score: _propTypes.default.number,
    totalAverageScore: _propTypes.default.number
  })).isRequired,
  radarAttr: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    key: _propTypes.default.string,
    color: _propTypes.default.string
  })).isRequired,
  dataKey: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired
};
var _default = exports.default = CRadarChart;